import { Alert, AlertProps, AlertTitle, Button, Stack } from '@mui/material'
import { RuuviTag } from '../types'
import { useTranslation } from 'react-i18next'
import RuuviTagDetachButton from './RuuviTagDetachButton'

export interface RuuviTagDetachAlertProps extends Omit<AlertProps, 'children' | 'onChange'> {
  ruuviTag: RuuviTag
  onChange?: (ruuviTag: RuuviTag) => void
  onCancel?: () => void
}

export default function RuuviTagDetachAlert({
  ruuviTag,
  onChange,
  onCancel,
  sx,
  ...props
}: RuuviTagDetachAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('ruuvitag')

  /**
   * Handle the "after submit" event.
   */
  function handleAfterSubmit(ruuviTag: RuuviTag) {
    onChange?.(ruuviTag)
  }

  return (
    <>
      {ruuviTag?.asset?.project && (
        <Alert
          severity="warning"
          sx={{
            '& .MuiAlert-message': {
              width: '100%'
            },
            ...sx
          }}
          {...props}
        >
          <AlertTitle sx={{ m: 0 }}>{t('RuuviTagDetachAlert.title')}</AlertTitle>

          <Stack direction="row" alignItems="center" gap={2} sx={{ mt: 1 }}>
            <RuuviTagDetachButton
              ruuviTag={ruuviTag}
              variant="outlined"
              color="inherit"
              size="small"
              buttonText={t('RuuviTagDetachAlert.yes')}
              afterSubmit={handleAfterSubmit}
            />

            <Button variant="outlined" color="inherit" onClick={onCancel}>
              {t('RuuviTagDetachAlert.no')}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
